import {roundMoney, toAmount} from '../services/billingService.js';

// Keep the existing FIFO credit order and each receipt's original date/mode.
// Allocating received advance is not a new cash receipt.
export function allocateAdvanceCredits(credits, requested, fallbackReceivedAt = '') {
  let remaining = Math.max(0, roundMoney(toAmount(requested)));
  const allocations = [];
  const updatedCredits = credits.map(credit => {
    const available = Math.max(0, roundMoney(toAmount(credit.remainingAmount)));
    const used = Math.min(available, remaining);
    if (used > 0) allocations.push({
      creditId: credit.creditId,
      amount: used,
      paymentMode: credit.paymentMode || 'Cash',
      transactionReference: credit.transactionReference || '',
      receivedAt: credit.receivedAt || fallbackReceivedAt,
      businessDate: credit.businessDate || '',
      source: credit.source || 'advance_credit',
    });
    remaining = roundMoney(Math.max(0, remaining - used));
    return {...credit, remainingAmount: roundMoney(Math.max(0, available - used))};
  });
  return {credits: updatedCredits, allocations, applied: roundMoney(Math.max(0, toAmount(requested)) - remaining)};
}
